(function() {
    angular.module('emarket.main.profile').factory('ChatMessage', ['restmod', function(restmod) {
        return restmod.model('/chat/messages');
    }]);
}());
